<template>
  <div>
    <nav id="nav" class="navbar navbar-expand-md navbar-dark bg-app">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <img alt="Logo" :src="image_url+'/images/logo.png'" class="img-fluid d-none d-md-block" />
          <h1 class="mob-title d-block d-md-none">The Onsite Safety Training Company</h1>
        </router-link>
        <div class="navbar-collapse" id="navbarCollapse">
          <div class="onMobile">
            <div class="sm-logo">
              <img
                alt="sm-logo"
                src="../images/logo-sm.png"
                class="logo-sm img-fluid d-block d-md-none"
              />
            </div>
            <div class="col-10">
              <ul class="navbar-nav ml-auto call">
                <li v-if="localTelNo">UK Wide: {{ localTelNo }}</li>
                <li v-if="internationalTelNo">Nat/Int: {{ internationalTelNo }}</li>
                </ul>
            </div>
            <div class="nav-btn">
              <a id="mob-nav" class="visible-xs nav-trigger d-block d-md-none">
                <div id="nav-btn" class="btn-burger"></div>
              </a>
            </div>
          </div>
          <ul class="navbar-nav ml-auto call d-none d-md-block">
            <li v-if="localTelNo">UK Wide: {{ localTelNo }}</li>
            <li v-if="internationalTelNo">Nat/Int: {{ internationalTelNo }}</li>
          </ul>
          <form @submit.prevent="performLocalSearch">
            <div class="input-group top-search">
              <input type="text" class="form-control search-query" placeholder="Search" id="q" name="q" v-model="localSearchQuery" required/>
              <div class="input-group-append">
                <button class="btn search-btn" type="submit" name="button">
                  <i class="fa fa-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </nav>
    <nav class="navbar navbar-expand-lg bg-white nav-bm d-none d-md-block">
      <div class="container box">
        <button
          class="navbar-toggler ml-auto"
          type="button"
          data-toggle="collapse"
          data-target="#collapsingNavbar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse pt-2 pt-md-0 menu" id="collapsingNavbar">
          <ul class="navbar-nav first">
            <li class="nav-item active" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link
                :to="{name: 'course-detail', params:{id:'health-and-safety-awareness-for-construction-workers-day-training-course'}}"
                class="nav-link"
              >Training Courses</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link line">|</a>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link
                class="nav-link"
                :to="{name: 'e-learning', params: {id:'health-and-safety-awareness-for-construction-works'}}"
              >E-learning</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link line">|</a>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <!--<router-link :to="{name: 'product-detail',params: {id: ['productsinfo','safety-training','dvds','construction-safety-awareness-dvd']}}" class="nav-link">DVDs</router-link> -->
              <router-link
                :to="{name: 'product-detail',params: {param1:'dvds', param2:'construction-safety-awareness-dvd'}}"
                class="nav-link"
              >DVDs</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link line">|</a>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link
                :to="{name: 'product-detail',params: {param1: 'booklets-and-manuals', param2:'construction-safety-manual'}}"
                class="nav-link"
              >Safety Manual</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link line">|</a>
            </li>
            <li
              class="nav-item dropdown"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <router-link
                :to="{name: 'product-detail',params: {param1: 'posters', param2:'construction-safety-posters-english'}}"
                class="nav-link"
              >Posters</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link line">|</a>
            </li>
            <li
              class="nav-item dropdown"
              data-toggle="collapse"
              data-target=".navbar-collapse.show"
            >
              <router-link
                :to="{name: 'product-detail',params: {param1: 'booklets-and-manuals', param2:'on-site-safety-booklets'}}"
                class="nav-link"
              >Booklets</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link line">|</a>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link to="/about" class="nav-link">About Us</router-link>
            </li>
            <li class="nav-item">
              <a class="nav-link line">|</a>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link class="nav-link" to="/contact">Contact Us</router-link>
            </li>
          </ul>

          <ul class="nav navbar-nav user ml-auto">
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <shopping-cart :cart="shoppingCart" :total="totalAmount"></shopping-cart>
            </li>
            <li class="nav-item">
              <a class="nav-link px-2 line">|</a>
            </li>
            <li class="nav-item" data-toggle="collapse" data-target=".navbar-collapse.show">
              <router-link to="/accounts" class="nav-link" v-if="$store.state.auth">My Account</router-link>
              <router-link class="nav-link" to="/login" v-if="!$store.state.auth">
                Login
                <img alt="user-logo" :src="image_url+'/images/user.svg'" />
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- Mobile Nav -->

    <nav id="main-nav" class="sidenav d-block d-md-none">
      <div class="nav-container">
        <div class="nav-wrapper nav-wrapper-0">
          <div class="nav-content">
            <h2></h2>
            <ul class="second-nav visible-xs">
              <li>
                <router-link to="/" class="nav-link mob-link">Home</router-link>
              </li>
              <li>
                <shopping-cart :cart="shoppingCart" :total="totalAmount"></shopping-cart>
              </li>
              <li>
                <router-link
                  to="/accounts"
                  class="nav-link mob-link login"
                  v-if="$store.state.auth"
                >My Account</router-link>
                <router-link class="login nav-link mob-link" to="/login" v-if="!$store.state.auth">
                  Login
                  <img alt="user-logo" :src="image_url+'/images/user.svg'" class="mob-link" />
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{name: 'course-detail', params:{id:'health-and-safety-awareness-for-construction-workers-day-training-course'}}"
                  class="nav-link mob-link"
                >Training Courses</router-link>
              </li>
              <li>
                <router-link
                  class="nav-link mob-link"
                  :to="{name: 'e-learning', params: {id:'health-and-safety-awareness-for-construction-works'}}"
                >E-learning</router-link>
              </li>
              <li>
                <router-link
                  :to="{name: 'product-detail',params: {param1:'dvds', param2:'construction-safety-awareness-dvd'}}"
                  class="nav-link mob-link"
                >DVDs</router-link>
              </li>
              <li>
                <router-link
                  :to="{name: 'product-detail',params: {param1: 'booklets-and-manuals', param2:'construction-safety-manual'}}"
                  class="nav-link mob-link"
                >Safety Manual</router-link>
              </li>
              <li>
                <router-link
                  :to="{name: 'product-detail',params: {param1: 'posters', param2:'construction-safety-posters-english'}}"
                  class="nav-link mob-link"
                >Posters</router-link>
              </li>
              <li>
                <router-link
                  :to="{name: 'product-detail',params: {param1: 'booklets-and-manuals', param2:'on-site-safety-booklets'}}"
                  class="nav-link mob-link"
                >Booklets</router-link>
              </li>
              <li>
                <router-link to="/about" class="nav-link mob-link">About Us</router-link>
              </li>
              <li>
                <router-link class="nav-link mob-link" to="/contact">Contact us</router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">You are offline</h5>
          </div>
          <div class="modal-body">Check your internet connection and try again.</div>
          <div class="modal-footer">
            <a href="/">
              <button type="button" class="btn btn-primary">Home</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShoppingCart from "../components/ShoppingCart.vue";
import home from "@/services/Home";
import GenericMixin from "@/assets/mixins/GenericMixin";
export default {
  name: "Header",
  components: {
    ShoppingCart
  },
  data() {
    return {
      posters: "",
      booklets: "",
      manual: "",
      image_url: process.env.VUE_APP_S3_IMAGE_URL,
      localSearchQuery: '',
    };
  },
  mixins: [GenericMixin],
  mounted() {
    // if (!this.$store.state.auth) {
    //   this.$router.replace(this.$route.query.redirect || "/");
    // }
  },
  computed: {
    shoppingCart() {
      return this.$store.state.cart;
    },
    products() {
      return this.$store.state.items;
    },
    totalAmount() {
      return this.$store.getters.total;
    }
  },
  created() {
    this.checkOffline();
  },
  methods: {
    checkOffline() {
      const channel = new BroadcastChannel("sw-messages");
      channel.addEventListener("message", event => {
        console.log("Received:::::", event.data);
        $("#exampleModal").modal("show");
      });
    },
    performLocalSearch() {
      const searchInput = document.getElementById('gsc-i-id1');
      const searchURL = `search#gsc.tab=0&gsc.q=${encodeURIComponent(this.localSearchQuery)}`;
      if(searchInput && searchInput.value != ''){
        if(searchInput.value !== this.localSearchQuery){
          this.$router.push(searchURL);
        }
      }else{
        // window.location.href = searchURL;
        this.$router.push(searchURL);
      }

    },
  }
};
</script>

<style lang="scss" scoped>
.bg-app {
  background-color: #1c3e7f !important;
}
.navbar-brand img {
  width: 430px;
}
.onMobile {
  display: none;
}
.call {
  color: white;
  font-size: 19px;
  font-weight: bold;
  margin-right: 35px;
}
.input-group.top-search {
  width: auto;
  display: flex !important;
  input {
    width: 80%;
    background: #3c5895;
    border: none;
    border-radius: 30px;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  input::placeholder {
    color: white;
  }
  button {
    background: #3c5895;
    border-radius: 30px;
    color: white;
    z-index: 0;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
.nav-bm {
  padding-top: 0;
  padding-bottom: 0;
  .box {
    //box-shadow: 0 15px 20px -15px rgba(0, 0, 0, 0.3);
  }
  .nav-link {
    color: #1b3d82 !important;
    font-size: 18px;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .line {
    padding-left: 2px !important;
    padding-right: 2px !important;
    margin-top: -2px;
  }
  .user .nav-link {
    font-size: 15px;
    color: #333333 !important;
  }
}
.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(0, 0, 0, 0.5)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E") !important;
}
.nav-trigger {
  position: relative;
  top: -5px;
  right: 9px;
  display: block;
  width: 30px;
  min-height: 24px;
  float: right;
  .btn-burger {
    width: 35px;
    height: 35px;
    border: 2px solid #ffffff;
    border-radius: 50px;
    background-image: url("../images/menu.png");
    transition: ease-in 1s;
  }
}
.btn-close {
  width: 18px;
  height: 18px;
  margin: 10px;
  top: 0;
  position: absolute;
}
#main-nav {
  transition: 0.5s;
}
.sidenav {
  position: fixed;
  top: 0;
  z-index: 5;
  right: 0;
  transition: 0.8s;
  text-align: left;
  .nav-container {
    transition: 0.5s;
    top: 100px;
    width: 300px;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    box-sizing: border-box;
    position: fixed;
    background: none;
  }
  .nav-wrapper {
    width: 100%;
    height: 100%;
    max-height: 100vh;
    overscroll-behavior: none;
    box-sizing: border-box;
    background: none;
    transition: ease-in 0.8s;
  }
  .nav-content {
    background: #f7f7f7;
    padding-top: 20px;
    padding-bottom: 150px;
    overflow: scroll;
    overflow-x: visible;
    overflow-y: auto;
    box-sizing: border-box;
    height: 100%;
    max-height: 100vh;
  }

  ul {
    list-style: none;
    padding-left: 0px;
    li {
      position: relative;
      display: block;
      a {
        font-size: 14px !important;
        font-weight: bold !important;
        color: #1b3d82 !important;
        font-weight: bold;
        font-size: 14px;
        padding: 14px 155px 14px 17px;
        position: relative;
        display: block;
        box-sizing: border-box;
      }
      hr {
        margin-bottom: 2px;
      }

      .login img {
        margin-left: 50px;
      }
      .login {
        border-bottom: 1px solid #8c8c89;
      }
    }
  }
  .second-nav hr {
    margin: 0;
  }
}

@media (max-width: 575px) {
  .onMobile {
    display: flex;
    .col-10 {
      padding: 0;
      top: 2px;
    }
    .logo-sm {
      max-width: 118%;
      //position: relative;
      //top: -5px;
    }
    .nav-trigger {
      right: 0px;
    }
  }
  .mob-title {
    font-size: 18px;
    color: #ffffff;
    padding: 5px;
    font-weight: bold;
    margin-bottom: 3px;
  }
  .input-group.top-search {
    display: none !important;
  }
  .call {
    font-size: 16px !important;
    text-align: center;
    margin: 0;
    //margin-bottom: 10px;
  }
  .nav-bm {
    text-align: left;
    .line {
      display: none;
    }
    .nav-link {
      font-size: 14px !important;
      font-weight: bold !important;
    }
  }
  .menu .navbar-nav {
    border-top: 1px solid #e4e5e4;
  }
  .bg-app {
    background-color: transparent !important;
  }
  .sidenav .nav-container .second-nav li .router-link-exact-active {
    color: black !important;
  }
}
</style>